(() => {
  const update = scope => {
    const select = scope?.querySelector('[data-ground-dispatch-select]');
    const note = scope?.querySelector('[data-ground-dispatch-note]');
    if (select && note) note.hidden = !select.value || select.value.trim().toLowerCase() === 'whole bean';
  };
  const start = () => document.querySelectorAll('[data-ground-dispatch-scope]').forEach(update);
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ground-dispatch-select]')) update(event.target.closest('[data-ground-dispatch-scope]'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
